import { requestGQL } from 'common/graphQlClient';
import { useMutation, useQueryClient } from 'react-query';

import { DELETE_OUTLET } from '../api';

export const useDeleteOutlet = (propertyId: null | number, outletId: null | string) => {
  const queryClient = useQueryClient();

  return useMutation<string>(
    async () =>
      requestGQL(DELETE_OUTLET, {
        propertyId,
        outletId,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['propertyConnection', propertyId]);
      },
      retry: false,
    },
  );
};
